module.exports = __webpack_public_path__ + "img/wechat-open.d11f5894.jpeg";